import { PerfectCursor } from 'perfect-cursors';
import { useCallback, useLayoutEffect, useState } from 'react';

/**
 * Wraps `perfect-cursors` to interpolate a stream of throttled point updates
 * into a smooth ~60Hz animation. The callback fires once per animation frame
 * with the interpolated point; pass it to a transform-only update path
 * (e.g. element.style.transform) to avoid React re-renders during the spline.
 *
 * Mirrors the React Flow collaborative-pro example src/lib/useSmoothing.tsx.
 * Used for remote cursor positions and remote in-flight edge moving endpoints
 * — both arrive at our 33ms throttle cadence; smoothing makes them feel 60Hz.
 */
export function useSmoothing(cb: (point: number[]) => void) {
  const [pc] = useState(() => new PerfectCursor(cb));

  useLayoutEffect(() => {
    return () => pc.dispose();
  }, [pc]);

  const onPointChange = useCallback(
    (point: number[]) => pc.addPoint(point),
    [pc],
  );

  return onPointChange;
}
